/* Product-specific waitlist. Never submits to Shopify's newsletter endpoint. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    root.NHWaitlist = api;
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', function () { api.init(root.document); });
    else api.init(root.document);
    root.document.addEventListener('shopify:section:load', function (event) { api.init(event.target); });
  }
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var PENDING_MESSAGE = 'Wenn die Anmeldung möglich ist, erhältst du eine E-Mail mit dem Bestätigungslink. Bitte prüfe auch deinen Spamordner.';
  var PREVIEW_MESSAGE = 'Die Anmeldung wurde in der lokalen Vorschau gespeichert. Es wurde keine E-Mail versendet.';

  function endpoint(base, campaign, isPreview) {
    if (!base || !/^[a-z0-9][a-z0-9-]{0,63}$/.test(campaign || '')) return '';
    if (isPreview === true && base === '/preview-api') return base + '/v1/waitlists/' + encodeURIComponent(campaign) + '/subscribe';
    try {
      var url = new URL(base);
      if (url.protocol !== 'https:' || url.username || url.password || url.search || url.hash || !/^\/*$/.test(url.pathname)) return '';
      return url.origin + '/v1/waitlists/' + encodeURIComponent(campaign) + '/subscribe';
    } catch (_) { return ''; }
  }

  function payload(email, consent, version, website) {
    return { email: String(email || '').trim(), consent: consent === true, consentVersion: String(version || ''), website: String(website || '') };
  }

  function init(scope) {
    var blocks = [];
    if (scope.matches && scope.matches('[data-nh-waitlist]')) blocks.push(scope);
    if (scope.querySelectorAll) blocks = blocks.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-nh-waitlist]')));
    blocks.forEach(bind);
  }

  function bind(block) {
    if (block.dataset.nhWaitlistReady === 'true') return;
    block.dataset.nhWaitlistReady = 'true';
    var form = block.querySelector('[data-nh-waitlist-form]');
    var status = block.querySelector('[data-nh-waitlist-status]');
    if (!form || !status) return;
    var email = form.elements.email;
    var consent = form.elements.consent;
    var button = form.querySelector('button[type="submit"]');
    var isPreview = block.dataset.preview === 'true';
    var target = endpoint(block.dataset.backendUrl, block.dataset.campaign, isPreview);
    var version = block.dataset.consentVersion;
    var busy = false;
    var done = false;
    var ready = Boolean(target && version && email && consent && button);
    if (!button || !email || !consent) return;
    button.disabled = !ready;
    if (!ready) {
      email.disabled = true;
      consent.disabled = true;
      setStatus('Die Warteliste öffnet in Kürze.', 'info', false);
    }

    function setStatus(message, state, focus) {
      status.textContent = message;
      status.dataset.state = state;
      if (focus) status.focus();
    }

    function clearInvalid(input) { input.removeAttribute('aria-invalid'); }
    email.addEventListener('input', function () { clearInvalid(email); });
    consent.addEventListener('change', function () { clearInvalid(consent); });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (!ready || busy || done) return;
      clearInvalid(email);
      clearInvalid(consent);
      if (!email.value.trim() || !email.validity.valid) {
        email.setAttribute('aria-invalid', 'true');
        setStatus('Bitte gib eine gültige E-Mail-Adresse ein.', 'error', false);
        email.focus();
        return;
      }
      if (!consent.checked) {
        consent.setAttribute('aria-invalid', 'true');
        setStatus('Bitte stimme der einmaligen Verkaufsbenachrichtigung zu.', 'error', false);
        consent.focus();
        return;
      }
      busy = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      setStatus('Deine Anmeldung wird vorbereitet …', 'info', false);
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 20000);
      try {
        var response = await fetch(target, {
          method: 'POST', mode: 'cors', credentials: 'omit', referrerPolicy: 'strict-origin-when-cross-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload(email.value, consent.checked, version, form.elements.website.value)),
          signal: controller.signal
        });
        var result = await response.json();
        if (!response.ok || result.ok !== true) {
          if (response.status === 429) throw new Error('rate-limit');
          throw new Error('submission');
        }
        done = true;
        email.disabled = true;
        consent.disabled = true;
        setStatus(isPreview ? PREVIEW_MESSAGE : PENDING_MESSAGE, 'success', true);
      } catch (error) {
        var message = error.message === 'rate-limit'
          ? 'Bitte warte einen Moment und versuche es später erneut.'
          : 'Die Anmeldung konnte gerade nicht abgeschlossen werden. Bitte versuche es gleich noch einmal.';
        setStatus(message, 'error', true);
      } finally {
        clearTimeout(timer);
        busy = false;
        button.disabled = done;
        button.removeAttribute('aria-busy');
      }
    });
  }

  return { init: init, endpoint: endpoint, payload: payload, pendingMessage: PENDING_MESSAGE };
});
